import { Fragment, useState } from 'react';
import { Formik } from "formik";
import * as Yup from "yup";

const Organisation = ({ state, updateState, nextStep, previousStep }) => {
  const [motoPayments, setMotoPayments] = useState(state?.data?.services?.moto_payments || false);
  const [linkPayments, setLinkPayments] = useState(state?.data?.services?.link_payments || false);
  const [ecommercePayments, setEcommercePayments] = useState(state?.data?.services?.ecommerce_payments || false);
  const [phonePayments, setPhonePayments] = useState(state?.data?.services?.phone_payments || false);

  return (
    <Formik
      initialValues={{
        descriptor: state?.data?.services?.descriptor || '',
        booking_system: state?.data?.services?.booking_system || '',
        processing_date: state?.data?.services?.processing_date || '',
      }}
      validationSchema={Yup.object().shape({
        descriptor: Yup
          .string()
          .required('Descriptor is required'),
        booking_system: Yup
          .string()
          .required('Booking System is required'),
        processing_date: Yup
          .string()
          .required('Processing Date is required'),
      })}
      onSubmit={async (values, {
        setSubmitting
      }) => {
        setSubmitting(true);
        updateState('services', {
          ...values,
          moto_payments: motoPayments,
          link_payments: linkPayments,
          ecommerce_payments: ecommercePayments,
          phone_payments: phonePayments,
        });
        nextStep();
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        touched,
        values,
      }) => (
        <Fragment>
          <form action="#" method="POST" onSubmit={handleSubmit}>

            <h1 className="text-2xl font-semibold mb-6">Required Services</h1>

            <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">

              <div className="gap-x-4 sm:col-span-2">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                  Do you want to take payments in person?
                </label>
                <div className="mt-2.5 clear">
                  <ul
                    className="items-center w-full text-sm font-medium text-gray-900 bg-white border rounded-lg sm:flex bg-gray-100 border-gray-300">
                    <li
                      onClick={() => setMotoPayments(true)}
                      className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r border-gray-300 cursor-pointer">
                      <div className="flex items-center cursor-pointer">
                        <input id="horizontal-list-radio-license" type="radio" value="" name="list-moto" checked={motoPayments === true} onChange={() => setMotoPayments(true)}
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 bg-gray-500 border-gray-500 cursor-pointer" />
                        <label htmlFor="horizontal-list-radio-license"
                          className="w-full py-3 ml-2 text-sm font-medium text-felloh cursor-pointer">Yes</label>
                      </div>
                    </li>
                    <li
                      onClick={() => setMotoPayments(false)}
                      className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r border-gray-300">
                      <div className="flex items-center">
                        <input id="horizontal-list-radio-id" type="radio" value="" name="list-moto" checked={motoPayments === false} onChange={() => setMotoPayments(false)}
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500 cursor-pointer" />
                        <label htmlFor="horizontal-list-radio-id"
                          className="w-full py-3 ml-2 text-sm font-medium text-felloh cursor-pointer">No</label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="gap-x-4 sm:col-span-2">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                  Do you want to send customers links to undertake payment?
                </label>
                <div className="mt-2.5 clear">
                  <ul
                    className="items-center w-full text-sm font-medium text-gray-900 bg-white border rounded-lg sm:flex bg-gray-100 border-gray-300">
                    <li
                      onClick={() => setLinkPayments(true)}
                      className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r border-gray-300">
                      <div className="flex items-center">
                        <input id="link-payments-true" type="radio" value="" name="list-link" checked={linkPayments === true} onChange={() => setLinkPayments(true)}
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 bg-gray-500 border-gray-500 cursor-pointer" />
                        <label htmlFor="link-payments-true"
                          className="w-full py-3 ml-2 text-sm font-medium text-felloh cursor-pointer">Yes</label>
                      </div>
                    </li>
                    <li
                      onClick={() => setLinkPayments(false)}
                      className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r border-gray-300">
                      <div className="flex items-center">
                        <input id="link-payments-false" type="radio" value="" name="list-link" checked={linkPayments === false} onChange={() => setLinkPayments(false)}
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500 cursor-pointer" />
                        <label htmlFor="link-payments-false"
                          className="w-full py-3 ml-2 text-sm font-medium text-felloh cursor-pointer">No</label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="gap-x-4 sm:col-span-2">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                  Take payments on your website via ecommerce integration?
                </label>
                <div className="mt-2.5 clear">
                  <ul
                    className="items-center w-full text-sm font-medium text-gray-900 bg-white border rounded-lg sm:flex bg-gray-100 border-gray-300">
                    <li
                      onClick={() => setEcommercePayments(true)}
                      className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r border-gray-300">
                      <div className="flex items-center">
                        <input id="ecommerce-payments-true" type="radio" value="" name="list-ecommerce" checked={ecommercePayments === true} onChange={() => setEcommercePayments(true)}
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 bg-gray-500 border-gray-500 cursor-pointer" />
                        <label htmlFor="ecommerce-payments-true"
                          className="w-full py-3 ml-2 text-sm font-medium text-felloh cursor-pointer">Yes</label>
                      </div>
                    </li>
                    <li
                      onClick={() => setEcommercePayments(false)}
                      className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r border-gray-300">
                      <div className="flex items-center">
                        <input id="ecommerce-payments-false" type="radio" value="" name="list-ecommerce" checked={ecommercePayments === false} onChange={() => setEcommercePayments(false)}
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500 cursor-pointer" />
                        <label htmlFor="ecommerce-payments-false"
                          className="w-full py-3 ml-2 text-sm font-medium text-felloh cursor-pointer">No</label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="gap-x-4 sm:col-span-2">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                  Take payments over the phone?
                </label>
                <div className="mt-2.5 clear">
                  <ul
                    className="items-center w-full text-sm font-medium text-gray-900 bg-white border rounded-lg sm:flex bg-gray-100 border-gray-300">
                    <li
                      onClick={() => setPhonePayments(true)}
                      className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r border-gray-300 cursor-pointer">
                      <div className="flex items-center">
                        <input id="phone-payments-true" type="radio" value="" name="list-phone" checked={phonePayments === true} onChange={() => setPhonePayments(true)}
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 bg-gray-500 border-gray-500" />
                        <label htmlFor="phone-payments-true"
                          className="w-full py-3 ml-2 text-sm font-medium text-felloh cursor-pointer">Yes</label>
                      </div>
                    </li>
                    <li
                      onClick={() => setPhonePayments(false)}
                      className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r border-gray-300 cursor-pointer">
                      <div className="flex items-center">
                        <input id="phone-payments-false" type="radio" value="" name="list-phone" checked={phonePayments === false} onChange={() => setPhonePayments(false)}
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                        <label htmlFor="phone-payments-false"
                          className="w-full py-3 ml-2 text-sm font-medium text-felloh cursor-pointer">No</label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>


              <div className="sm:col-span-2 mb-2">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold" htmlFor="grid-state">
                  What do you want your card descriptor to be? *
                </label>
                <p className="text-xs text-felloh">This will appear on your customers bank statements</p>
                <div className="mt-2.5">
                  <input type="text"
                    name="descriptor"
                    id="descriptor"
                    value={values.descriptor}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    placeholder={'e.g. My Agency LTD'}
                    className={`block appearance-none w-full rounded-md border border-gray-200 text-gray-900 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500${touched.descriptor && errors.descriptor ? ' border-red-500' : ''}`}
                  />
                  {touched.descriptor && errors.descriptor && <div className="field-error">{errors.descriptor}</div>}
                </div>
              </div>

              <div className="sm:col-span-2 mb-2">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                  What booking system do you currently use? *
                </label>
                <div className="mt-2.5">
                  <input type="text"
                    name="booking_system"
                    id="booking_system"
                    value={values.booking_system}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    placeholder={'e.g. TravelJoy'}
                    className={`block appearance-none w-full rounded-md border border-gray-200 text-gray-900 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500${touched.booking_system && errors.booking_system ? ' border-red-500' : ''}`}
                  />
                  {touched.booking_system && errors.booking_system && <div className="field-error">{errors.booking_system}</div>}
                </div>
              </div>

              <div className="sm:col-span-2 mb-2">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="processing_date">
                  What Date do you want to start processing? *
                </label>
                <div className="mt-2.5">
                  <input
                    type="date"
                    name="processing_date"
                    id="processing_date"
                    value={values.processing_date || ''}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    className={`block appearance-none w-full rounded-md border border-gray-200 text-gray-900 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500${touched.processing_date && errors.processing_date ? ' border-red-500' : ''}`}
                  />
                  {touched.processing_date && errors.processing_date && <div className="field-error">{errors.processing_date}</div>}
                </div>
              </div>

            </div>

            <div className="mt-12">
              <button type="submit"
                className="bg-purple-800 disabled:bg-purple-200 hover:bg-purple-900 text-white font-semibold rounded-md py-2 px-4 w-full">
                Next
              </button>
            </div>

            <div className="mt-4">
              <button type="button"
                onClick={previousStep}
                className="block w-full rounded-md bg-slate-300 px-3.5 py-2.5 text-center text-md font-semibold text-black shadow-sm hover:text-white hover:bg-slate-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-600">
                Previous
              </button>
            </div>
          </form>
        </Fragment>
      )}
    </Formik>
  );
}

export default Organisation;
